import { isArray } from 'lodash'

function removeNullValues(
  obj: any,
  opt?: {
    removeEmptyStrings: boolean;
    removeEmptyArray: boolean;
  }
) {
  for (let key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    } else if (isArray(obj[key]) && obj[key].length === 0 && opt?.removeEmptyArray) {
      delete obj[key];
    } else if (obj[key] == "" && opt?.removeEmptyStrings) {
      delete obj[key];
    }
    
  }
  return obj;
}

export default removeNullValues;